var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternal = function SvgIconExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.75 4H7.6c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C4 5.709 4 6.339 4 7.6v4.8c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984C5.709 16 6.339 16 7.6 16h4.8c1.26 0 1.89 0 2.371-.245a2.25 2.25 0 0 0 .984-.984c.245-.48.245-1.11.245-2.371v-.15M11.5 4H16m0 0v4.5M16 4l-6.75 6.75"
  })));
};
export default SvgIconExternal;